<template>
    <v-menu
      v-model="menu"
      offset-y>
        <template v-slot:activator="{ on }">
            <template v-on="on"></template>
            <span
              style="display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; user-select: none"
              :style="{cursor: readonly ? null : 'pointer'}"
              @click.exact="if (!readonly && !menu) { toggle_school() } else if (readonly) { $emit('readonly_fail') }"
              @click.right.exact="open_context_menu()"
              v-longpress="() => { if ($vuetify.breakpoint.mobile) { open_context_menu() } }"
              >
                <school-icon
                  :school_state="value.school"
                  :training_state="value.training"
                  :dark="dark">
                </school-icon>
            </span>
        </template>
        <v-card
          flat
          style="text-align: center; overflow: hidden">
            <template v-for="(school_state, idx) in states.school">
                <div
                  v-if="school_state != value.school && !(school_state == 'biweekly_1' || (value.school == 'biweekly_1' && school_state == 'biweekly_0') || (value.training == 'no' && school_state.startsWith('biweekly')))"
                  :key="idx"
                  @click.exact="set_school(school_state)"
                  class="py-5"
                  style="width:100%; cursor: pointer">
                    <school-icon
                      :school_state="school_state"
                      :training_state="value.training"
                      :dark="dark">
                    </school-icon>
                </div>
            </template>
        </v-card>
    </v-menu>
</template>

<script>

import SchoolIcon from './SchoolIcon.vue'
import EventBus from './EventBus.js'


export default {
    name: 'SchoolCell',
    props: {
        dark: Boolean,
        value: {
            type: Object,
            default: () => ({
                school: 'no',
                training: 'no'
            })
        },
        readonly: Boolean
    },
    data: function () {
        return {
            menu: false,
            emitter: false,
            states: {
                school: ['no', 'normal', 'biweekly_0', 'biweekly_1'],
                training: ['no', 'normal', 'morning'],
            },
        }
    },
    methods: {
        set_school: function (school_state) {
            this.$emit('input', {...this.value,
                                 school: school_state})
        },
        open_context_menu: function () {
            if (!this.readonly) {
                this.emitter = true
                EventBus.$emit('close_all')
            } else {
                this.$emit('readonly_fail')
            }
        },
        toggle_school: function () {
            if (this.value.school == 'no') {
                this.set_school('normal')
            } else {
                if (this.value.school == 'biweekly_0') {
                    this.set_school('biweekly_1')
                } else if (this.value.school == 'biweekly_1') {
                    this.set_school('biweekly_0')
                } else {
                    this.set_school('no')
                }
            }
        },
    },
    mounted: function () {
        var self = this
        EventBus.$on('close_all', function () {
            if (!self.emitter) {
                self.menu = false
            } else {
                self.emitter = false
                self.menu = true
            }
        })
    },
    components: {
        SchoolIcon
    }
}

</script>
